import { ConsumerLoanTargetPath, PatchApplicationRequest } from '../domain/types';
import { IFormData } from '../store/applicationform/applicationFormTypes';
import { apiClient } from './apiClient';
import { callbackUrl, dataFormPage } from './util';

const buildPatchBody = (request: PatchApplicationRequest) =>
    dataFormPage(
        {
            applicationId: request.applicationReferenceNumber,
            callbackUrl: callbackUrl(
                ConsumerLoanTargetPath.callback,
                request.languageCode,
                request.countryCode,
                request.applicationReferenceNumber,
            ),
            applicationUrl: callbackUrl(
                ConsumerLoanTargetPath.ongoing,
                request.languageCode,
                request.countryCode,
                request.applicationReferenceNumber,
            ),
        },
        request.formFieldStates,
    );

export const patchApplicationService = async (request: PatchApplicationRequest): Promise<IFormData> => {
    return apiClient<IFormData>(
        `${request.proxyBaseUrl}/application/${request.applicationReferenceNumber}/${request.languageCode}`,
        {
            method: 'PATCH',
            body: buildPatchBody(request),
            apiKey: request.apiKey,
            authenticationData: request.authenticationData,
            sentryTag: 'patch_application',
            sentryExtra: { arn: request.applicationReferenceNumber, languageCode: request.languageCode },
        },
    );
};

export const patchExternalConsentService = async (request: PatchApplicationRequest): Promise<IFormData> => {
    return apiClient<IFormData>(
        `${request.proxyBaseUrl}/application/${request.applicationReferenceNumber}/external_consent`,
        {
            method: 'PATCH',
            body: buildPatchBody(request),
            apiKey: request.apiKey,
            authenticationData: request.authenticationData,
            sentryTag: 'patch_external_consent',
            sentryExtra: { arn: request.applicationReferenceNumber },
        },
    );
};

/**
 * This is a temporary endpoint to trigger the next step in the orchestration process after signing the application.
 *
 * @param request
 * @returns a promise with a void
 */
export const afterSignApplication = async (request: PatchApplicationRequest): Promise<void> => {
    await apiClient<void>(`${request.proxyBaseUrl}/application/${request.applicationReferenceNumber}/signed`, {
        method: 'GET',
        apiKey: request.apiKey,
        authenticationData: request.authenticationData,
        responseType: 'void',
        sentryTag: 'after_sign_application',
        sentryExtra: { arn: request.applicationReferenceNumber },
    });
};
